import { useObserver } from "mobx-react-lite";
import { useCallback, useMemo } from "react";

import {
  DEFAULT_PLAYBACK_MODE,
  TimelinePlaybackMode,
} from "@/store/helpers/threadSessionStorage";
import {
  ThreadSessionStore,
  threadSessionManager,
} from "@/store/threadSession";

interface UseThreadTimelinePlaybackResult {
  playbackMode: TimelinePlaybackMode;
  setPlaybackMode: (mode: TimelinePlaybackMode) => Promise<void>;
}

export function useThreadTimelinePlayback(
  threadId: string
): UseThreadTimelinePlaybackResult {
  const sessionStore: ThreadSessionStore = useMemo(() => {
    return threadSessionManager.get(threadId);
  }, [threadId]);

  const setPlaybackMode = useCallback(
    (mode: TimelinePlaybackMode) => {
      return sessionStore.setTimelinePlaybackMode(mode);
    },
    [sessionStore]
  );

  const playbackMode = useObserver(
    () => sessionStore.timelinePlaybackMode ?? DEFAULT_PLAYBACK_MODE
  );

  return {
    playbackMode,
    setPlaybackMode,
  };
}
